import { $axios, withAuth } from '@/shared/api';

export const signUpUser = ({ email, language, mobile }) => {
  return $axios.post('auth/sign-up/email',
    {
      email,
      language,
      mobile,
      role: 'Teacher',
    },
  );
};

export const confirmEmail = (data) => {
  return $axios.post('auth/confirm', data);
};

export const signInUser = async (data) => {
  return $axios.post('auth/sign-in/email', data);
};

export const getUserToken = () => {
  return $axios.get('auth/getUserToken', withAuth());
};

export const resetPassword = (data) => {
  return $axios.post('auth/reset-password/request', data);
};

export const resetPasswordConfirm = (data) => {
  return $axios.patch('auth/reset-password/confirm', data);
};

export const loginLog = (data) => {
  return $axios.post('auth/login', data, withAuth());
};